var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4da",
    fillRule: "evenodd",
    d: "M1.374 20.427c.426.18.875.314 1.302.404q.639.135 1.212.135c.381 0 .763-.045 1.212-.135q.64-.134 1.279-.404.64-.27 1.078-.741c.291-.336.426-.718.426-1.122V9.676l9.629-2.963v6.733c-.718-.336-1.526-.493-2.401-.493q-.573 0-1.213.134c-.426.09-.875.225-1.301.404a2.9 2.9 0 0 0-1.078.763 1.59 1.59 0 0 0-.426 1.1c0 .427.135.786.426 1.123a3.1 3.1 0 0 0 1.078.74c.426.18.875.314 1.301.404q.64.135 1.213.135c.381 0 .763-.045 1.212-.135q.64-.134 1.279-.404a3.06 3.06 0 0 0 1.077-.74c.292-.337.427-.719.427-1.123V1.326c0-.337-.112-.629-.359-.853a1.1 1.1 0 0 0-.831-.359.86.86 0 0 0-.359.067L7.142 3.391a1.16 1.16 0 0 0-.606.426c-.157.225-.246.449-.246.718v12.121c-.719-.337-1.527-.494-2.402-.494a6 6 0 0 0-1.212.135c-.427.09-.876.224-1.302.404a3.1 3.1 0 0 0-1.077.741 1.63 1.63 0 0 0-.427 1.122c0 .404.135.786.427 1.122q.437.472 1.077.741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaMusic);
export default __webpack_public_path__ + "static/media/fa-music.88c4d21639dff5acf76f7fef3536aece.svg";
export { ForwardRef as ReactComponent };